import './styles.scss'
import {IWidgetResponse} from '../../../api/Base/Base.types'
import NumberUtils from "../../../utils/number.utils";
import WidgetNivoBase from "../Widget.nivo.base";
import {ITopInTransitLanes} from "../../../api/TopInTransitLanes/TopInTransitLanes.types";

interface Props {
    data?: IWidgetResponse<ITopInTransitLanes>
}

function TopInTransitLanes({data}: Props) {
    function getData() {
        if (data) {
            return data.data
                .sort((a, b) => b.inTransitCount - a.inTransitCount)
                .map(d => ({ports: `${d.portOfLoading} to ${d.portOfDischarge}`, inTransitCount: d.inTransitCount})
                );

        }
    }

    return (
        <div className="top-transits-in-lane">
            <WidgetNivoBase.Bar
                title="Top Transits In Lane"
                data={getData()}
                keys={["inTransitCount"]}
                indexBy="ports"
                axisLeftName="# In Transit"
                axisBottomName="Lane"
                axisBottomRotation={-45}
                formatValue={v => NumberUtils.toShortened(v, 2)}
                formatXAxis={v => {
                    let split = v.split(" to ");
                    return `${split[0].slice(0, 3)}-${split[1].slice(0, 3)}`
                }}
                tooltip={(props) => {
                    const {indexValue, value, color} = props;
                    return (
                        <div style={{padding: 12, color, background: "#222222", borderRadius: 10}}>
                            <div>{indexValue}</div>
                            <strong>{NumberUtils.numberWithCommas(value)} In Transit</strong>
                        </div>
                    )
                }}
            />
        </div>
    )
}

export default TopInTransitLanes;